import type { FaireProductEntity } from "../../entity_types/product";

export const p_wucsnphsb4: FaireProductEntity = {
  token: "p_wucsnphsb4",
  type: "product",
  name: "83229 Big Llama Squishy-6",
  brandToken: "b_6e309hxy0g",
  brandName: "BCmini",
  imageUrl:
    "https://cdn.faire.com/fastly/312d1e10f36cb07abfd4ade67b84635fc855f004aee641aa314725a71cb5e3cf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d1d06ec583b1779e7db6226e28205a3a30c3d81f95d8a4638bb74a5e13c265ef.jpeg",
  ],
  priceDollars: 4,
  description:
    "83229 big llama squishy. $4, $24 for 6.\n\nThe cutest, softest, and slowest rising squishes. Each squishy is individually packed in a peggable display bag. Food, animals, and more fun colorful styles are all available.",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:45.761Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
